import { JSONEditor } from '@json-editor/json-editor'
import { defer } from 'lodash'
import EventBus from '../../helpers/event-bus'

const BaseEditor = JSONEditor.defaults.editors.object

function updateHiddenRecursively (editor) {
  if (!editor || !editor.editors) return
  const editorsArray = Object.values(editor.editors)
  editorsArray.forEach(e => updateHiddenRecursively(e))
  let hideEditor = editorsArray.every(e => {
    if (!e || !e.options) return false
    if (e.container && e.container.style.display === 'none') return true
    return e.options.hidden
  })
  editor.options.hidden = hideEditor
  if (editor.options.hidden) {
    editor.container.style.display = 'none'
  }
}

class ObjectEditor extends BaseEditor {

  _setTimeoutId = null

  constructor (options, defaults) {
    options = Object.assign(options, {
      collapsed: false
    })
    super(options, defaults)
    this.isBasic = options.jsoneditor.options.isBasic || false
    // console.log('ObjectEditor isBasic:', this)
  }

  build () {
    super.build()
    if (this.title && this.controls) {
      this.title.appendChild(this.controls)
    }
    // if its already hidden dont keep going
    if (this.options.hidden) return
    // reason for the following code is cards takes to long to load sub content and it races so this waits until ALL are ready to apply the hidden recursive logic 
    // acts as an observer pattern waiting for all schemas to be loaded/ready
    if (this.jsoneditor.ready) {
      updateHiddenRecursively(this)
    } else {
      const pollReady = () => {
        if (this.jsoneditor.ready) {
          updateHiddenRecursively(this)
        } else {
          this._setTimeoutId = setTimeout(pollReady, 50)
        }
      }
      pollReady()
    }
  }

  destroy () {
    if (this._setTimeoutId) {
      clearTimeout(this._setTimeoutId)
      this._setTimeoutId = null
    }
    super.destroy()
  }

  showAddProperty () {
    if (!this.addproperty_holder) return

    super.showAddProperty()

    this.addproperty_holder.style.left = ''
    this.addproperty_holder.style.right = '0px'
  }

  getWatchedFieldValues () {
    const mTitle = this.display_text?.[this.type] || this.getTitle()
    return { ...super.getWatchedFieldValues(), mTitle }
  }
}

export default ObjectEditor
